// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_overlay__WZGBs {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000000cc;
}
.Modal_closeIcon__h0SUN {
  width: 24px;
  height: 24;
  position: absolute;
  right: 3%;
  top: 5%;
  cursor: pointer;
  background-color: transparent;
  border: none;
}
.Modal_overlay__WZGBs,
.Modal_container__l5xjh,
.Modal_btnRow__7ZHUm,
.Modal_acceptBtn__k5z2F,
.Modal_cancelBtn__g1z32 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Modal_container__l5xjh {
  width: 40%;
  height: 390px;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 6px 32px 6px 32px;
}
.Modal_wrapper__qpO5D {
  width: 90%;
  gap: 24px;
}
.Modal_wrapper__qpO5D,
.Modal_checkboxWrapper__hWNGx {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-direction: column;
}
.Modal_title__1Ef2r {
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  color: #4d4d4d;
}
.Modal_title__1Ef2r,
.Modal_label__v9YS4,
.Modal_checkboxLabel__KIT9j {
  font-family: Inter;
  letter-spacing: -0.001em;
  text-align: left;
}
.Modal_label__v9YS4,
.Modal_checkboxLabel__KIT9j {
  font-size: 16px;
  line-height: 22px;
  color: #5f6d7e;
}
.Modal_label__v9YS4 {
  font-weight: 500;
}
.Modal_checkboxLabel__KIT9j {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
}
.Modal_checkboxInput__w\\+eUr {
  display: none;
}
.Modal_checkboxInput__w\\+eUr:checked + .Modal_checkboxCustom__7HVOd {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center
    no-repeat;
}
.Modal_checkboxCustom__7HVOd {
  width: 20px;
  height: 20px;
  border: 1px solid #5f6d7e;
  background-color: white;
  margin-right: 10px;
  border-radius: 100px;
}
.Modal_btnRow__7ZHUm {
  width: 100%;
  gap: 16px;
  margin-top: 16px;
}

.Modal_cancelBtn__g1z32,
.Modal_acceptBtn__k5z2F {
  font-family: Inter;
  font-weight: 600;
  text-align: left;
  height: 40px;
  padding: 30px 80px 30px 80px;
  border: none;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  border-radius: 4px;
  width: 100%;
  transition: backgroundColor 300ms ease-in-out;
  cursor: pointer;
}
.Modal_cancelBtn__g1z32:hover {
  background-color: #d8dbdf;
  color: #4e4e4e;
}
.Modal_acceptBtn__k5z2F:hover {
  background-color: #8d6a19;
}
.Modal_acceptBtn__k5z2F {
  background-color: #cb9c2d;
  color: #ffffff;
}
.Modal_cancelBtn__g1z32 {
  color: #808080;
  background-color: #ebebeb;
}
.Modal_checkboxWrapper__hWNGx {
  width: 100%;
  margin-top: 16px;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/PojedinaPrijavnica/PrijavnicaContainer/components/AGSModal/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;aACW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".overlay {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #000000cc;\n}\n.closeIcon {\n  width: 24px;\n  height: 24;\n  position: absolute;\n  right: 3%;\n  top: 5%;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n.overlay,\n.container,\n.btnRow,\n.acceptBtn,\n.cancelBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.container {\n  width: 40%;\n  height: 390px;\n  border-radius: 16px;\n  background-color: #ffffff;\n  padding: 6px 32px 6px 32px;\n}\n.wrapper {\n  width: 90%;\n  gap: 24px;\n}\n.wrapper,\n.checkboxWrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  flex-direction: column;\n}\n.title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  color: #4d4d4d;\n}\n.title,\n.label,\n.checkboxLabel {\n  font-family: Inter;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.label,\n.checkboxLabel {\n  font-size: 16px;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n.label {\n  font-weight: 500;\n}\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 600;\n}\n.checkboxInput {\n  display: none;\n}\n.checkboxInput:checked + .checkboxCustom {\n  background: url(\"../../../../../assets/img/Checkbox.png\") center center\n    no-repeat;\n}\n.checkboxCustom {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #5f6d7e;\n  background-color: white;\n  margin-right: 10px;\n  border-radius: 100px;\n}\n.btnRow {\n  width: 100%;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.cancelBtn,\n.acceptBtn {\n  font-family: Inter;\n  font-weight: 600;\n  text-align: left;\n  height: 40px;\n  padding: 30px 80px 30px 80px;\n  border: none;\n  text-align: center;\n  color: #ffffff;\n  font-size: 16px;\n  border-radius: 4px;\n  width: 100%;\n  transition: backgroundColor 300ms ease-in-out;\n  cursor: pointer;\n}\n.cancelBtn:hover {\n  background-color: #d8dbdf;\n  color: #4e4e4e;\n}\n.acceptBtn:hover {\n  background-color: #8d6a19;\n}\n.acceptBtn {\n  background-color: #cb9c2d;\n  color: #ffffff;\n}\n.cancelBtn {\n  color: #808080;\n  background-color: #ebebeb;\n}\n.checkboxWrapper {\n  width: 100%;\n  margin-top: 16px;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Modal_overlay__WZGBs`,
	"closeIcon": `Modal_closeIcon__h0SUN`,
	"container": `Modal_container__l5xjh`,
	"btnRow": `Modal_btnRow__7ZHUm`,
	"acceptBtn": `Modal_acceptBtn__k5z2F`,
	"cancelBtn": `Modal_cancelBtn__g1z32`,
	"wrapper": `Modal_wrapper__qpO5D`,
	"checkboxWrapper": `Modal_checkboxWrapper__hWNGx`,
	"title": `Modal_title__1Ef2r`,
	"label": `Modal_label__v9YS4`,
	"checkboxLabel": `Modal_checkboxLabel__KIT9j`,
	"checkboxInput": `Modal_checkboxInput__w+eUr`,
	"checkboxCustom": `Modal_checkboxCustom__7HVOd`
};
export default ___CSS_LOADER_EXPORT___;
